import type { FC, PropsWithChildren } from 'react';
import React from 'react';

import { LocaleContext, defaultLocale } from './context';

interface LocaleProviderProps {
  readonly locale: string | undefined;
}

const LocaleProvider: FC<PropsWithChildren<LocaleProviderProps>> = ({ children, locale = defaultLocale }) => (
  <LocaleContext.Provider value={locale}>{children}</LocaleContext.Provider>
);

export default LocaleProvider;
